import type { PomodoroConfig, PlanSession, SessionType } from './types';

const uuid = () => crypto.randomUUID();

const clampConfigValue = (value: unknown, min: number, max: number, fallback: number) => {
  const numeric = typeof value === 'number' && Number.isFinite(value) ? Math.round(value) : fallback;
  return Math.min(Math.max(numeric, min), max);
};

export const normalizePomodoroConfig = (config: PomodoroConfig): PomodoroConfig => ({
  workDuration: clampConfigValue(config.workDuration, 1, 90, 25),
  shortBreakDuration: clampConfigValue(config.shortBreakDuration, 1, 30, 5),
  longBreakDuration: clampConfigValue(config.longBreakDuration, 1, 60, 15),
  sessionsBeforeLongBreak: clampConfigValue(config.sessionsBeforeLongBreak, 1, 8, 4),
  totalSessions: clampConfigValue(config.totalSessions, 0, 12, 0)
});

export const buildPlanSessions = (planId: string, config: PomodoroConfig): PlanSession[] => {
  const safeConfig = normalizePomodoroConfig(config);
  const sessions: PlanSession[] = [];
  const total = safeConfig.totalSessions;

  for (let i = 0; i < total; i += 1) {
    const sessionNumber = i + 1;
    const isLongBreak = sessionNumber % safeConfig.sessionsBeforeLongBreak === 0;
    sessions.push({
      id: uuid(),
      planId,
      index: sessions.length,
      type: 'work',
      duration: safeConfig.workDuration,
      startedAt: null,
      endedAt: null,
      completed: false
    });

    if (sessionNumber < total) {
      sessions.push({
        id: uuid(),
        planId,
        index: sessions.length,
        type: isLongBreak ? 'long_break' : 'short_break',
        duration: isLongBreak ? safeConfig.longBreakDuration : safeConfig.shortBreakDuration,
        startedAt: null,
        endedAt: null,
        completed: false
      });
    }
  }

  return sessions;
};

export const getSessionLabel = (type: SessionType): string => {
  if (type === 'work') return 'Focus';
  if (type === 'short_break') return 'Short Break';
  return 'Long Break';
};
